import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IButton } from "@models/entity-models";
import { eRuleType } from "@models/enums";

@Kbo(CToken.Button)
export class Button extends UiObject implements IButton {

    constructor(kom: KbObjectManager) {
        super(kom, { ruleType: eRuleType.button });
    }

    public enabled: boolean;
    public icon: string;
    public iconStyle: string;
    public textPosition: string;
    public mediaPath: string;
    public showLabel: boolean;
    public buttonStyle: string;
    public fullWidth: boolean;
    public relativeWidth: string;
    public imageHeight: number;
    public imageWidth: number;
    
}
